/* tslint:disable: member-ordering*/
import { of as observableOf ,  Observable } from 'rxjs';

import {
    share,
    exhaustMap,
    catchError,
    map,
    withLatestFrom,
    switchMap,
} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { UserAcceptCampaignActions } from './user-accept-campaign.actions';
import { Store } from '@ngrx/store';
import { AppState } from '../../interfaces/app-state.interface';
import { UserAcceptCampaignService } from '../../services/user-accept-campaign/user-accept-campaign.service';

@Injectable()
export class UserAcceptCampaignEffects {
    constructor(
        private store: Store<AppState>,
        private actions$: Actions,        
        private userAcceptCampaignService: UserAcceptCampaignService
    ) { }
    
    /** Busca as campanhas disponiveis para o cliente toro assinar */
    getUserAcceptCampaign$ = createEffect(() => this.actions$.pipe(
        ofType(UserAcceptCampaignActions.getUserAcceptCampaign),
        withLatestFrom(this.store.select((state) => state.userAcceptCampaign)),
        exhaustMap(([action, state]) => {
            if (
                state.userAcceptCampaignData.length > 0
            ) {
                return observableOf({
                    type: UserAcceptCampaignActions.getUserAcceptCampaignSuccess,
                    payload: {
                        data: state.userAcceptCampaignData
                    },
                });
            }

            return this.userAcceptCampaignService
                .getUserAcceptCampaing()
                .pipe(
                    map((result: any) => {
                        if (result.length > 0) {
                            return {
                                type: UserAcceptCampaignActions.getUserAcceptCampaignSuccess,
                                payload: {
                                    data: result,
                                },
                            };
                        }

                        return {
                            type: UserAcceptCampaignActions.getUserAcceptCampaignError,
                            payload: {
                                data: result,
                            },
                        };
                    }),
                    catchError((error) => {
                        return observableOf({
                            type: UserAcceptCampaignActions.getUserAcceptCampaignError,
                            payload: {
                                data: error,
                            },
                        });
                    })
                );
        }),
        share()
    ));    

    /** Metodo para o usuário para aderir campanha */
    putUserAcceptCampaign$ = createEffect(() => this.actions$
        .pipe(
            ofType(UserAcceptCampaignActions.putUserAcceptCampaign),
            switchMap((action: any) => {
                console.log('action Effects =>', action)
                const payload = {
                    guidContrato: action.guidContrato,
                };

                return this.userAcceptCampaignService
                    .putUserAcceptCampaing(payload)
                    .pipe(
                        map((result) => {
                            console.log('Result Effects =>', result)
                            if (result.accept) {
                                return {
                                    type: UserAcceptCampaignActions.putUserAcceptCampaignSuccess,
                                    payload: {
                                        data: result,
                                    },
                                };
                            }

                            return {
                                type: UserAcceptCampaignActions.putUserAcceptCampaignError,
                                payload: {
                                    data: result,
                                },
                            };
                        }),
                        catchError((error) => {
                        console.log('error Effects =>', error)
                            return observableOf({
                                type: UserAcceptCampaignActions.putUserAcceptCampaignError,
                                payload: {
                                    data: error,
                                },
                            });
                        })
                        );
            }),
            share()));
    
}
